module.exports = __webpack_public_path__ + "static/media/intelex-logo.01a6d0c5.svg";